<circulation-dialog [title]="'circulation.cancel.dialog.title'" [content]="'circulation.cancel.dialog.content'"
  [(opened)]="cancelDialogOpened" (dialogClosed)="onCancelDialogClosed($event)"></circulation-dialog>
<circ-loader [isLoading]="!isReady()"></circ-loader>
<div class="details-header d-flex gap-3" *ngIf="circulation && isReady()">
  <div class="col info-card circ-info pl-0">
    <circ-information [circulation]="circulation$" [permissions]="permissions$" [steps]="steps"
      (editCirculation)="editCirculation()" (startCirculation)="startCirculation()"
      (cancelCirculation)="cancelCirculation()" (copyCirculation)="copyCirculation()"></circ-information>
  </div>

  <!-- Current Step -->
  <div class="col info-card step-info pl-5 pr-0">
    <circ-step-current [steps]="steps | async" style="height: 100%;"></circ-step-current>
  </div>
</div>

<!-- Step Grid -->
<div class="row mt-sm-5" *ngIf="isReady()">
  <div class="col">
    <circ-step-grid [circStatus]="(circulation$ | async)?.props.status" [steps]="steps | async"
      (workClick)="onWork($event)" (editClick)="onEdit($event)" (overrideClick)="onOverride($event)"
      (forwardClick)="onForward($event)" (addClick)="addStep()" (reorderClick)="reorderSteps()"
      [canAddStep]="canAddStep"></circ-step-grid>
  </div>
</div>

<!-- Documents & Links -->
<div class="row mt-sm-5"
  *ngIf="isReady() && ((permissions$ | async)?.canAddDocuments || (document$ | async).length > 0)">
  <div class="col">
    <kendo-card [width]="'auto'">
      <div class="k-vbox">
        <kendo-card-header>
          <h4>{{ "circ_details_documents_header" | i18n }}</h4>
        </kendo-card-header>
        <kendo-card-body>
          <div class="container-fluid">
            <div class="row">
              <div class="col-xs-12 col-md-6" *ngIf="(permissions$ | async)?.canAddDocuments">
                <circ-document-upload></circ-document-upload>
              </div>
              <div class="col-xs-12 col-md-6">
                <div *ngIf="(permissions$ | async).canAddDocuments">
                  <kendo-label [text]="'circ.document.hyperlink.uploadTitle' | i18n">
                    <circ-add-hyperlink (add)="onAddHyperlink($event)"></circ-add-hyperlink>
                  </kendo-label>
                </div>
                <br>
                <kendo-label [text]="'circ.document.list.header' | i18n"
                  *ngIf="(permissions$ | async)?.canAddDocuments">
                </kendo-label>
                <circ-document-list [documents]="document$ | async" (documentDelete)="onDeleteDocument($event)"
                  (documentOpen)="onOpenDocument($event)"
                  (documentDownload)="onDownloadDocument($event)"></circ-document-list>
                <div *ngIf="hasDownloadableDocs$ | async">
                  <ece-btn-icon [text]="'circ.details.documents.downloadAll' | i18n" [icon]="'download'"
                    (click)="onDownloadAllDocuments()"></ece-btn-icon>
                </div>
                <circ-loader [isLoading]="downloadInProgress" [background]="'rgba(5,5,5,0.1)'"
                  [marginTop]="'50%'"></circ-loader>
              </div>
            </div>
          </div>
        </kendo-card-body>
      </div>
    </kendo-card>
  </div>
</div>